$(document).ready(function () {
    $('.distributor-row').hide();
    $('#item-filter-select').on('change', function () {
        var elems = this.value == 'all' ? $('.distributor-row') : $('.distributor-row[data-type="'+this.value+'"]');
        $('.distributor-row').not(elems.show()).hide();
    });
});
